import { getMetaUserAdvancedMatchingFields } from "@workspace/analytics/meta-user-advanced-matching";
import { env } from "@/env";
import { normalizeUruguayWhatsapp } from "@/lib/meta-lead";

export function trackMetaLead(input: {
  eventId: string;
  name: string;
  whatsapp: string;
}) {
  const fbq = window.fbq;
  if (!fbq) {
    return;
  }

  const pixelId = env.NEXT_PUBLIC_META_PIXEL_ID;
  const matching = getMetaUserAdvancedMatchingFields({ name: input.name });
  const phone = normalizeUruguayWhatsapp(input.whatsapp);

  fbq("init", pixelId, {
    ...(phone ? { ph: phone } : {}),
    ...(matching.firstName ? { fn: matching.firstName } : {}),
    ...(matching.lastName ? { ln: matching.lastName } : {}),
  });
  fbq("trackSingle", pixelId, "Lead", {}, { eventID: input.eventId });
}

declare global {
  interface Window {
    fbq?: (
      command: string,
      pixelId: string,
      eventOrOptions?: string | Record<string, unknown>,
      options?: Record<string, unknown>,
      metadata?: Record<string, unknown>,
    ) => void;
  }
}
